import { z } from 'zod';

export enum EvalAssertionType {
  AGENT_CALLED_TOOL = 'AGENT_CALLED_TOOL',
  AGENT_DID_NOT_CALL_TOOL = 'AGENT_DID_NOT_CALL_TOOL',
  AGENT_SAID_EXACTLY = 'AGENT_SAID_EXACTLY',
  AGENT_DID_NOT_SAY_EXACTLY = 'AGENT_DID_NOT_SAY_EXACTLY',
  LLM_MULTI_CHOICE = 'LLM_MULTI_CHOICE',
}

export const LlmMultiChoiceOptionSchema = z.object({
  label: z.string(),
  score: z.number().min(0).max(1),
});
export type LlmMultiChoiceOption = z.infer<typeof LlmMultiChoiceOptionSchema>;

export const ToolInputMatcherSchema = z.object({
  path: z.string(),
  pattern: z.string(),
});
export type ToolInputMatcher = z.infer<typeof ToolInputMatcherSchema>;

export const EvalAssertionSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal(EvalAssertionType.AGENT_CALLED_TOOL),
    toolName: z.string(),
    toolInput: z.record(z.unknown()).optional(),
    toolInputMatchers: z.array(ToolInputMatcherSchema).optional(),
  }),
  z.object({
    type: z.literal(EvalAssertionType.AGENT_DID_NOT_CALL_TOOL),
    toolName: z.string(),
    toolInput: z.record(z.unknown()).optional(),
    toolInputMatchers: z.array(ToolInputMatcherSchema).optional(),
  }),
  z.object({
    type: z.literal(EvalAssertionType.AGENT_SAID_EXACTLY),
    pattern: z.string(),
  }),
  z.object({
    type: z.literal(EvalAssertionType.AGENT_DID_NOT_SAY_EXACTLY),
    pattern: z.string(),
  }),
  z.object({
    type: z.literal(EvalAssertionType.LLM_MULTI_CHOICE),
    prompt: z.string(),
    options: z.array(LlmMultiChoiceOptionSchema).min(2),
  }),
]);
export type EvalAssertion = z.infer<typeof EvalAssertionSchema>;

export const ASSERTIONS_EXPECTED_VERSION = 'ASSERTIONS_V1' as const;

export const AssertionExpectedSchema = z.object({
  version: z.literal(ASSERTIONS_EXPECTED_VERSION),
  assertions: z.array(EvalAssertionSchema),
});
export type AssertionExpected = z.infer<typeof AssertionExpectedSchema>;

export function isAssertionExpected(
  value: unknown
): value is AssertionExpected {
  return AssertionExpectedSchema.safeParse(value).success;
}
